<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Mechanical Connections</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationDetailRow">
        @if (handArrangementSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Arrangement:</label>
            <select class="halfWidthInputField" #handArrangementInput
              [class.invalidConfigurationSelection]="isInvalidSelection(handArrangementSelection.Name)"
              (change)="selectionChanged(handArrangementSelection, handArrangementInput.value)"
              [value]="handArrangementSelection.Value.toString()">
              @for (allowable of handArrangementSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="handArrangementSelection.Value && handArrangementSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
        @if (supplyAirOptionSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Supply Air Options:</label>
            <select class="halfWidthInputField" #supplyAirOptionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirOptionSelection.Name)"
              (change)="selectionChanged(supplyAirOptionSelection, supplyAirOptionsInput.value)"
              [value]="supplyAirOptionSelection.Value.toString()">
              @for (allowable of supplyAirOptionSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="supplyAirOptionSelection.Value && supplyAirOptionSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (paintOptionsSelection) {
          <span class="halfWidthConfigurationInput">
            <label class="halfWidthInputLabel">Paint Options:</label>
            <select class="halfWidthInputField" #paintOptionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
              (change)="selectionChanged(paintOptionsSelection, paintOptionsInput.value)"
              [value]="paintOptionsSelection.Value.toString()">
              @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="configurationDetailRow">
        @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
          <img class="handArrangementImage"
            [src]="handArrangementImagePath()" alt="UnitImage"/>
        }
      </div>
    </div>
  }
</div>
